import {
  Component,
  Inject,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgImageSliderComponent } from 'ng-image-slider';
import { DomSanitizer } from '@angular/platform-browser';
import { HomeService } from 'src/app/shared/services/home.service';

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss']
})
export class IframeDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<IframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public sanitizer: DomSanitizer,
    private homeService: HomeService
  ) {}
  docExtensions = [
    'pdf',
    'txt',
  ];
  pptExtension = ['ppt', 'pptx'];
  wordExtension = ['doc', 'docm', 'docx'];
  excelExtensions = [ 'csv', 'xls', 'xlsb', 'xlsx', ];
  imgExtensions = ['jpeg', 'jpg', 'png', 'gif', 'raw', 'image'];
  videoExtensions = [
    'mp4',
    'mov',
    'wmv',
    'avi',
    'avchd',
    'flv',
    'f4v',
    'swf',
    'mkv',
    'webm',
    'mpeg-2',
  ];

  @ViewChild('nav') slider: NgImageSliderComponent | undefined;

  url: any;

  getDownloadLink(): string {
    return 'https://www.akamai.com/site/im-demo/perceptual-standard.jpg?imbypass=true';
  }
  ngOnInit(): void {
  }

  downloadCount(id: any, requestType: any): void {
    const el = document.getElementsByClassName('carousel-item active');
    let downloadIndex = '';
    if (el) {
      downloadIndex = el[1] && el[1].id || el[0].id;
      this.downloadFile(this.data.fileList[downloadIndex]);
    }

    this.homeService.countApi(this.data.fileList[downloadIndex].id, requestType).subscribe(
      (res: any) => {});
  }

  downloadFile(fileData: any): void {
    this.url = fileData.fileUrl;
  }



  getReturnType(type: string): string {
    if (this.imgExtensions.includes(type.toLowerCase())) {
      return 'image';
    }
    if (this.videoExtensions.includes(type.toLowerCase())) {
      return 'video';
    }
    if (this.docExtensions.includes(type.toLowerCase())) {
      return 'pdf';
    }
    if (this.excelExtensions.includes(type.toLowerCase())) {
      return 'excel';
    }
    if (this.wordExtension.includes(type.toLowerCase())) {
      return 'word';
    }
    if (this.pptExtension.includes(type.toLowerCase())) {
      return 'ppt';
    }
    return 'default';
  }
  geturl(url: string): any {
    const newUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url + '#toolbar=0');
    return newUrl;

  }
  getDocUrl(url: string): any {
    const prefixUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=';
    const suffixUrl =  url;
    const fullUrl = prefixUrl + suffixUrl;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }

}
